import { Component } from "@angular/core";

@Component({
  selector: "app-layout-with-header",
  templateUrl: "./layoutWithHeader.component.html",
  styleUrls: ["./layoutWithHeader.component.css"],
})
export class LayoutWithHeaderComponent {
  constructor() {}
}